import { render, staticRenderFns } from "./adtoom.vue?vue&type=template&id=db9be9e4&scoped=true"
import script from "./adtoom.vue?vue&type=script&lang=js"
export * from "./adtoom.vue?vue&type=script&lang=js"
import style0 from "./adtoom.vue?vue&type=style&index=0&id=db9be9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9be9e4",
  null
  
)

export default component.exports